import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { uk } from "date-fns/locale";

import { RootState } from "@/store/store";
import { toggleVisibilityCalendarInScheduleHeader } from "@/store/ui/ui";
import CalendarComponent from "@/components/Calendar/Calendar";
import Button from "@/shared/components/Button/Button";
import useGetStatistic from "@/hooks/useGetStatistic";

import "../../ScheduleComponents/ScheduleHeader/ScheduleHeader.scss";
import "./StatsDebtorsHeader.scss";

export default function StatsDebtorsHeader() {
    const dispatch = useDispatch();
    const isVisibleCalendarInSheduleHeader = useSelector(
        (state: RootState) => state.ui.isVisibleCalendarInSheduleHeader,
    );
    const globalDate = useSelector(
        (state: RootState) => state.schedule.globalDate,
    );
    const { handleGetStats } = useGetStatistic();

    async function getDebtors() {
        await handleGetStats({
            entity: "debtors",
            message: "Звіт про боржників сформовано",
        });
    }

    return (
        <div className='stats__debt_header_container'>
            <div className='schedule_header_actual_data'>
                {format(globalDate, "EEE, d MMMM yyyy", {
                    locale: uk,
                }).replace(/^./, char => char.toLocaleUpperCase())}
            </div>
            <button
                className='icon_container calendar'
                onClick={() =>
                    dispatch(
                        toggleVisibilityCalendarInScheduleHeader(
                            !isVisibleCalendarInSheduleHeader,
                        ),
                    )
                }
            />
            <div className='stats__debt_header_button_container'>
                <Button
                    text={"Зформувати звіт"}
                    variant='approved'
                    disabled={isVisibleCalendarInSheduleHeader}
                    onClick={getDebtors}
                />
            </div>
            <CalendarComponent />
        </div>
    );
}
